/** @jsxImportSource @emotion/react */
import React, { Component } from 'react';
import { css } from '@emotion/react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { H2 } from '../containers/Headers';
import Icon from '../icon/Icon';

class SideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      intervalId: 0
    };
  }

  componentDidUpdate(prevProps) {
    const { isOpen } = this.props;
    if (isOpen && !prevProps.isOpen) {
      this.scrollToTop();
    }
  }

  setRef = node => (this.sidebarRef = node);

  scrollStep() {
    const { intervalId } = this.state;
    if (window.pageYOffset === 0) {
      clearInterval(intervalId);
    }
    window.scroll(0, window.pageYOffset - 50);
  }

  scrollToTop() {
    const intervalId = setInterval(this.scrollStep.bind(this), 15);
    this.setState({ intervalId: intervalId });
  }

  render() {
    const { isOpen, title, children, closeSidebar, hasHeader, isStatic, extraClassName, scrollRef } = this.props;

    return (
      <div
        className={classnames('bg-white', {
          'show-sidebar': isOpen,
          'static-sidebar': isStatic,
          'sidebar-container': !isStatic
        })}
        tabIndex='-1'
      >
        <div
          className={classnames(`sidebar-aside border-right bg-white ta-sm-c mb4-sm ${extraClassName}`)}
          ref={scrollRef}
        >
          <div className={classnames('pt4-sm pb4-sm prl5-sm', { 'header mb7-sm z1': hasHeader })}>
            {!!closeSidebar && (
              <button
                type='button'
                onClick={closeSidebar}
                aria-label='close'
                data-desc='sidebar__button_close'
                className='close'
              >
                <Icon name='chevron-left-cell' alt='close menu' />
              </button>
            )}
            {!!title && (
              <H2
                css={
                  extraClassName.includes('allotments_details')
                    ? css`
                        width: 90%;
                        display: flex;
                        margin-left: 15px;
                        justify-content: center;
                      `
                    : ''
                }
                data-desc='sidebar__title'
              >
                {title}
              </H2>
            )}
          </div>
          <div className='base prl6-sm mt3-sm bg-white'>{children} </div>
        </div>
      </div>
    );
  }
}

SideBar.defaultProps = {
  children: null,
  hasHeader: true,
  closeSidebar: null,
  isStatic: false,
  title: '',
  extraClassName: '',
  scrollRef: null
};

SideBar.propTypes = {
  children: PropTypes.any,
  closeSidebar: PropTypes.func,
  hasHeader: PropTypes.bool,
  title: PropTypes.any,
  isOpen: PropTypes.bool.isRequired,
  isStatic: PropTypes.bool,
  extraClassName: PropTypes.string,
  scrollRef: PropTypes.any
};

export default SideBar;
